import fullText from './fullText'
import mediaAndText from './mediaAndText'
import photoWall from './photoWall'
import carousel from './carousel'
import navigation from './navigation'
import i18n from '@/i18n'
import jobList from './jobList'
import form from './form'
import navigationPage from './navigationPage'
import videoNavigation from './videoNavigation'

const modules = {
  [fullText.name]: fullText,
  [mediaAndText.name]: mediaAndText,
  [photoWall.name]: photoWall,
  [carousel.name]: carousel,
  [navigation.name]: navigation,
  [jobList.name]: jobList,
  [form.name]: form,
  [navigationPage.name]: navigationPage,
  [videoNavigation.name]: videoNavigation
}

function createRenderData (tag, index, parent) {
  const module = modules[tag]
  return module && module.createRenderData && module.createRenderData(tag, index, parent)
}

function createChildRenderData (parent) {
  const module = modules[parent.tag]
  return module && module.createChildRenderData && module.createChildRenderData(parent)
}

function getEditorTitle (renderData, isAddType) {
  const module = modules[renderData.tag] || (renderData.parent && modules[renderData.parent.tag])
  const title = (module && module.getEditorTitle && module.getEditorTitle(renderData)) || ''
  return (isAddType ? i18n.t('microSite.editor.component.add') : i18n.t('microSite.editor.component.edit')) + title + i18n.t('microSite.editor.component.component')
}

function getProjectItemTitle (renderData) {
  const module = modules[renderData.tag] || (renderData.parent && modules[renderData.parent.tag])
  const title = (module && module.getEditorTitle && module.getEditorTitle(renderData)) || ''
  return title + i18n.t('microSite.editor.common.component')
}

function getAvailableTags () {
  const noRenderModeTpyes = [fullText, carousel, navigation, jobList, navigationPage, videoNavigation]

  // 无子render mode的类型
  const availableRenderModeTags = []
  for (const type of noRenderModeTpyes) {
    if (type.toolbarItems[0].isShow) {
      availableRenderModeTags.push(type.name)
    }
  }

  return availableRenderModeTags
}

function getAvailableRenderType () {
  const renderModeTypes = [mediaAndText, photoWall, form]
  // 有子render mode的类型
  const availableRenderModes = []
  for (const type of renderModeTypes) {
    for (const item of type.toolbarItems) {
      if (item.isShow && item.staticProps && item.staticProps.renderMode) {
        availableRenderModes.push(item.staticProps.renderMode)
      }
    }
  }

  return availableRenderModes
}

const availableRenderModeTags = getAvailableTags()
const availableRenderModes = getAvailableRenderType()

function isModuleAvailable (renderData) {
  if (renderData.tag === 'div' || renderData.tag === navigation.name) {
    return true
  }
  const children = renderData.children
  let targetData = renderData
  if (children === null && targetData.parent.tag !== 'div') {
    targetData = targetData.parent
  }
  const renderMode = targetData.data.props.renderMode
  return availableRenderModeTags.indexOf(targetData.tag) > -1 ||
    availableRenderModes.indexOf(renderMode) > -1
}

// 根据背景颜色生成文字颜色（黑或白）
function getTextColorByBgColor (bkgColor) {
  bkgColor = bkgColor.replace('#', '')
  const r = parseInt(bkgColor.substr(0, 2), 16)
  const g = parseInt(bkgColor.substr(2, 2), 16)
  const b = parseInt(bkgColor.substr(4, 2), 16)
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000
  return (yiq >= 160) ? '#000000' : '#FFFFFF'
}

// 生成颜色的相近色。
// amount: 程度，正负对应浅深。
function getSimilarColorByColor (color, amount) {
  return '#' + color.replace(/^#/, '')
    .replace(/../g, color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2))
}

const allToolbarItems = [
  ...fullText.toolbarItems,
  ...mediaAndText.toolbarItems,
  ...photoWall.toolbarItems,
  ...carousel.toolbarItems,
  ...navigation.toolbarItems,
  ...jobList.toolbarItems,
  ...form.toolbarItems,
  ...navigationPage.toolbarItems,
  ...videoNavigation.toolbarItems
]

const allRenders = {
  ...fullText.renders,
  ...mediaAndText.renders,
  ...photoWall.renders,
  ...carousel.renders,
  ...navigation.renders,
  ...jobList.renders,
  ...form.renders,
  ...navigationPage.renders,
  ...videoNavigation.renders
}

const allEditors = {
  ...fullText.editors,
  ...mediaAndText.editors,
  ...photoWall.editors,
  ...carousel.editors,
  ...navigation.editors,
  ...jobList.editors,
  ...form.editors,
  ...navigationPage.editors,
  ...videoNavigation.editors
}

function createRootCssStyle (bgColor, btnColor) {
  if (!bgColor) {
    bgColor = '#FFFFFF'
  }
  if (!btnColor) {
    btnColor = '#FFFFFF'
  }
  const color = getTextColorByBgColor(bgColor)
  const fontColor = btnColor
  const btnBgColor = btnColor
  btnColor = getTextColorByBgColor(btnBgColor)
  let cssStyle = `
    .site-render.site-common,
    .site-render.site-common .page-render {
      background-color: ${bgColor};
    }

    .site-render.site-common .custom-color {
      color: ${color};
    }

    .site-render.site-common .custom-border-color {
      border-color: ${btnBgColor};
    }

    .site-render.site-common .custom-background-color {
      background-color: ${bgColor};
    }

    .site-render.site-common .custom-btn {
      color: ${btnColor};
      background-color: ${btnBgColor};
    }

    .site-render.site-common .custom-font-color {
      color: ${fontColor} !important;
    }
  `
  if (color === '#FFFFFF') {
    const textColor = `
      .site-render.site-common .module-text-title,
      .site-render.site-common .module-text-subtitle,
      .site-render.site-common .module-text-content {
        color: ${color};
      }
    `
    cssStyle = cssStyle.concat(textColor)
  }
  return cssStyle
}

export default modules

export {
  allToolbarItems,
  allRenders,
  allEditors,
  getEditorTitle,
  getProjectItemTitle,
  createRenderData,
  createChildRenderData,
  availableRenderModes,
  availableRenderModeTags,
  isModuleAvailable,
  getTextColorByBgColor,
  getSimilarColorByColor,
  createRootCssStyle
}
